<template>
  <!--html do computador-->
  <div class="hidden-sm hidden-xs">

    <header>
      <div class="header-area">
        <div class="main-header ">

          <!-- barra estreita topo -->
          <div class="header-top d-none d-sm-block">
            <div class="container-fluid">
              <div class="row">
                <div class="col-xl-12">
                  <div class="d-flex justify-content-between flex-wrap align-items-center">
                    <div v-if="topoMenu != ''" class="header-info-left">
                      <ul>
                        <li><i class="fas fa-phone-alt"></i> {{ topoMenu[0].itiNome }}</li>
                        <li>{{ topoMenu[0].itiCampoExtra1 }}</li>
                      </ul>
                    </div>
                    <div v-if="redesSociais != ''" class="header-info-right">
                      <ul class="header-social">
                        <li><a v-if="redesSociais[0].itiNome != 0 && redesSociais[0].itiNome != null"
                            :href="redesSociais[0].itiNome" target="_blank"><i class="fab fa-facebook"></i></a>
                        </li>
                        <li><a v-if="redesSociais[0].itiReferencia != 0 && redesSociais[0].itiReferencia != null"
                            :href="redesSociais[0].itiReferencia" target="_blank"><i class="fab fa-instagram"></i></a>
                        </li>
                        <li><a v-if="redesSociais[0].itiCampoExtra2 != 0 && redesSociais[0].itiCampoExtra2 != null"
                            :href="redesSociais[0].itiCampoExtra2" target="_blank"><i
                              class="fab fa-linkedin-in"></i></a></li>
                        <li><a v-if="redesSociais[0].itiCampoExtra1 != 0 && redesSociais[0].itiCampoExtra1 != null"
                            :href="redesSociais[0].itiCampoExtra1" target="_blank"><i class="fab fa-youtube"></i></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- menu -->
          <div class="header-bottom  header-sticky">
            <div class="container-fluid">
              <div class="row align-items-center">
                <!-- Logo -->
                <div class="col-xl-2 col-lg-2">
                  <div class="logo">
                    <router-link to="/"><img :src="$imagens + 'logo.png'" alt=""></router-link>
                  </div>
                </div>
                <div class="col-xl-10 col-lg-10">

                  <!-- Main-menu -->
                  <div class="main-menu d-none d-lg-block" style="justify-content: center;">
                    <nav>
                      <ul id="navigation">
                        <li><router-link to="/">Home</router-link></li>
                        <li><router-link to="/sobre">Sobre a Empresa</router-link></li>
                        <li><a href="#">Conheça nossa linha de Produtos</a>
                          <ul v-if="segmentospais != '' && segmentospais.length > 0" class="submenu">
                            <li v-for="menu in segmentospais" :key="menu.sgiId"><router-link
                                :to="'/Produto/' + menu.sgiId + '/' + formataLink(menu.sgiNomeSegmento)">{{
                                  menu.sgiNomeSegmento }}</router-link></li>
                          </ul>
                        </li>
                        <li v-show="false"><router-link to="/blog">Igor News</router-link></li>
                        <li v-show="false"><router-link to="/Representantes">Representantes</router-link></li>
                        <li><router-link to="/contato">Fale Conosco</router-link></li>
                        <li>
                          <div v-if="topoMenu != ''" class="header-right-btn f-right  ml-15">
                            <a :href="topoMenu[0].itiLinkBtn1" target="_blank" class="header-btn">
                              <i class="fab fa-whatsapp"></i> Orçamento</a>
                          </div>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </header>

  </div>

  <!--html do celular-->
  <div class="container hidden-lg hidden-md" style="position:absolute; z-index: 3; background-color: #000;">
    <div class="row celular-alinhado">
      <div class="col-3">
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-dots-vertical" v-bind="props"></v-btn>
          </template>
          <v-list class="celular-topo">
            <v-list-item><router-link to="/"><v-list-item-title class=" menu"
                  style="color: #000000;">Home</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/sobre"><v-list-item-title class=" menu"
                  style="color: #000000;">Sobre</v-list-item-title></router-link></v-list-item>
            <v-list-item v-for="menu in segmentospais" :key="menu.sgiId"><router-link
                :to="'/Produto/' + menu.sgiId + '/' + formataLink(menu.sgiNomeSegmento)"><v-list-item-title
                  class=" menu" style="color: #000000; font-weight: 600;">{{ menu.sgiNomeSegmento
                  }}</v-list-item-title></router-link></v-list-item>
             <v-list-item v-show="false"><router-link to="/representantes"><v-list-item-title class=" menu"
                  style="color: #000000;">Representantes</v-list-item-title></router-link></v-list-item>
            <v-list-item v-show="false"><router-link to="/blog"><v-list-item-title class=" menu"
                  style="color: #000000;">Igor News</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/contato"><v-list-item-title class=" menu"
                  style="color: #000000;">Contato</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link :to="topoMenu[0].itiLinkBtn1" target="_blank" class="header-btn"><v-list-item-title class=" menu"
                  style="color: #000000;"><i class="fab fa-whatsapp"></i> Orçamento</v-list-item-title></router-link></v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="col-9">
        <router-link to="/"><img src="/images/logo.png" alt=""></router-link>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageHeader',
  components: {

  },
  data: () => ({
    topoMenu: [],
    redesSociais: [],
    segmentospais: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),
  methods: {
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
  },
  async created() {
    // dados topo 
    axios.get('/Process/InsInstitucional/institucional/9/cabecalho/0/x')
      .then(response => {
        this.topoMenu = response.data;
        //console.log('topo menu')
        //console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });

    // redes sociais 
    axios.get('/Process/InsInstitucional/institucional/20/redessociais/0/x')
      .then(response => {
        this.redesSociais = response.data;
        //console.log('redesSociais')
        //console.log(this.redesSociais)
      })
      .catch(error => {
        console.error(error);
      });

    // lista segmentos
      const segmentosRes = await axios.get('/Process/InsSegmentos/GetAll');
			this.segmentospais = segmentosRes.data
				.filter(x => x.sgiIdPai == 0 && x.sgiVisivel)
				.sort((a, b) => a.sgiNomeSegmento.localeCompare(b.sgiNomeSegmento));

        //console.log('segmentospais')
        //console.log(this.segmentospais)
  }
};
</script>

<style scoped>
.menu {
  line-height: 1.2; /* padrão costuma ser 1.5 */
  font-size: 16px;
  font-weight: 400;
  transition: color 0.3s;
  padding: 4px 0; /* opcional: controla o espaçamento vertical */
}

.menu:hover {
  color: #c0a01e; /* muda cor ao passar o mouse */
} 

.celular-topo {
  padding: 0;
  margin: 0;
  background-color: #FAF7F2; /* cor de fundo opcional */
  margin-top: 10px;
}
/* reduz altura e espaçamento dos itens */
.celular-topo .v-list-item {
  min-height: 36px; /* padrão é 48px */
  padding-top: 6px;
  padding-bottom: 6px;
}

/* estilização dos textos */
.celular-topo .menu {
  font-size: 15px;
  font-weight: 400;
  color: #000000;
  line-height: 1.2; /* diminui entrelinha */
  transition: color 0.3s ease;
}

/* efeito hover */
.celular-topo .menu:hover {
  color: #009688; /* cor ao passar o mouse */
}

/* botão whatsapp / orçamento */
.celular-topo .header-btn .menu {
  font-weight: 600;
  color: #000000;
}

/* opcional: centraliza ícone e texto */
.celular-topo .header-btn i {
  margin-right: 6px;
  font-size: 16px;
  vertical-align: middle;
}

/* remove sublinhado do router-link */
.celular-topo a {
  text-decoration: none;
}

.celular-alinhado {
  display: flex;
  justify-content: space-between;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
}
</style>
